import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-xxl demand-letter-container pt-4 pb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar_component = _resolveComponent("navbar-component")!
  const _component_matter_name = _resolveComponent("matter-name")!
  const _component_demand_letter_process_section = _resolveComponent("demand-letter-process-section")!
  const _component_general_info = _resolveComponent("general-info")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_navbar_component),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          _createVNode(_component_matter_name, { "matter-name": _ctx.matterName }, null, 8, ["matter-name"]),
          _createVNode(_component_demand_letter_process_section, {
            ref: "processSection",
            "session-data": _ctx.sessionData,
            status: _ctx.sessionData.status,
            "session-id": _ctx.sessionId,
            "handle-fetch-session-info": _ctx.fetchSessionInfo
          }, null, 8, ["session-data", "status", "session-id", "handle-fetch-session-info"]),
          (_ctx.isGeneralInfoFetched)
            ? (_openBlock(), _createBlock(_component_general_info, {
                key: 0,
                "inputs-data": _ctx.generalInfoInputs,
                "session-id": _ctx.sessionId,
                "session-status": _ctx.sessionData.status,
                "matter-name": _ctx.matterName,
                "selected-template-name": _ctx.sessionData.generalInfo.templateName,
                "additional-info": _ctx.additionalInfo
              }, null, 8, ["inputs-data", "session-id", "session-status", "matter-name", "selected-template-name", "additional-info"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_component_loading_spinner, { key: 1 }))
  ], 64))
}